export const PROPERTY_KIND_OPTIONS = [
  ['parcel', 'भूखंड'],
  ['building', 'इमारत'],
  ['unit', 'स्वतंत्र युनिट'],
];

export const USAGE_OPTIONS = [
  ['residential', 'निवासी / Residential'],
  ['commercial', 'व्यावसायिक / Commercial'],
  ['industrial', 'औद्योगिक / Industrial'],
  ['agricultural', 'शेती / Agricultural'],
  ['mixed', 'मिश्र वापर / Mixed'],
  ['institutional', 'संस्थात्मक / Institutional'],
  ['vacant', 'मोकळा भूखंड / Open Plot (रिक्त)'],
  ['other', 'इतर / Other'],
];

export const CONSTRUCTION_TYPE_OPTIONS = [
  ['rcc', 'आरसीसी (RCC / सिमेंट काँक्रीट)'],
  ['load_bearing', 'पक्के / भारवाहक (Load Bearing)'],
  ['semi_paka', 'अर्ध-पक्के / पत्र्याची छत (Semi-Paka)'],
  ['kachha', 'कच्चे / माती-कौलारू (Kachha)'],
  ['open_plot', 'खुला भूखंड (Open Plot)'],
  ['other', 'इतर'],
];

export const PROPERTY_STATUS_OPTIONS = [
  ['active', 'सक्रिय'],
  ['inactive', 'निष्क्रिय'],
  ['demolished', 'पाडलेली'],
  ['merged', 'विलीन'],
  ['archived', 'संग्रहित'],
];

export const VERIFICATION_OPTIONS = [
  ['draft', 'मसुदा'],
  ['pending', 'पडताळणी प्रलंबित'],
  ['verified', 'पडताळलेले'],
  ['rejected', 'नामंजूर'],
  ['archived', 'संग्रहित'],
];

export const INTEREST_OPTIONS = [
  ['owner', 'मालक'],
  ['co_owner', 'सहमालक'],
  ['life_interest', 'आजीवन हक्कधारक'],
  ['liable_holder', 'करदायी धारक'],
  ['government', 'शासकीय मालकी'],
  ['other', 'इतर'],
];

export const OCCUPANCY_OPTIONS = [
  ['owner_occupied', 'मालक वास्तव्यास'],
  ['tenant', 'भाडेकरू'],
  ['licensee', 'परवानाधारक'],
  ['vacant', 'रिक्त'],
  ['institutional', 'संस्थात्मक'],
  ['other', 'इतर'],
];

export const VALUATION_SOURCE_OPTIONS = [
  ['manual', 'कार्यालयीन नोंद'],
  ['survey', 'सर्वेक्षण'],
  ['rule_calculated', 'नियमाधारित गणना'],
  ['migration', 'जुनी स्थलांतरित नोंद'],
  ['appeal', 'अपील निर्णय'],
];

export const SERVICE_TYPE_OPTIONS = [
  ['water', 'पाणी'],
  ['sanitation', 'स्वच्छता'],
  ['street_light', 'पथदिवा'],
  ['waste', 'कचरा संकलन'],
  ['other', 'इतर'],
];

export const labelFor = (options, value) => options.find(([key]) => key === value)?.[1] || value || '—';

export const workflowStatusLabel = value => ({
  draft: 'मसुदा', pending: 'प्रलंबित', pending_approval: 'मंजुरी प्रलंबित',
  approved: 'मंजूर', superseded: 'पूर्व आवृत्ती', rejected: 'नामंजूर',
  active: 'सक्रिय', inactive: 'निष्क्रिय', ended: 'समाप्त', disconnected: 'जोडणी बंद',
  archived: 'संग्रहित', cancelled: 'रद्द',
}[value] || 'स्थिती उपलब्ध नाही');

export const today = () => new Date().toISOString().slice(0, 10);

export const PROPERTY_TAX_FIELD_LABELS = {
  usage_type: 'वापर प्रकार',
  construction_type: 'बांधकाम प्रकार',
  land_area_sqft: 'जमीन क्षेत्रफळ',
  built_up_area_sqft: 'बांधकाम क्षेत्रफळ',
  water_tax_type: 'पाणीपट्टी प्रकार',
  approved_property_valuation: 'मंजूर मालमत्ता मूल्यांकन',
  assessed_value: 'आकारणी मूल्य',
  annual_rental_value: 'वार्षिक भाडेमूल्य (ARV)',
  land_value: 'जमीन मूल्य',
  building_value: 'इमारत मूल्य',
  piped_water_connection: 'नळ पाणी जोडणी',
  water_connection_number: 'नळ जोडणी क्रमांक',
  water_tariff_class: 'पाणी दरवर्ग',
  water_connection_date: 'नळ जोडणी दिनांक',
};

export const apiErrorMessage = (error, fallback = 'काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.') => {
  const payload = error?.response?.data;
  if (typeof payload === 'string' && payload.trim()) return payload;
  const summary = payload?.message || payload?.error;
  const details = Array.isArray(payload?.details)
    ? payload.details.map(detail => PROPERTY_TAX_FIELD_LABELS[detail?.field] || detail?.message || detail?.field).filter(Boolean)
    : [];
  if (summary && details.length) return `${summary}: ${[...new Set(details)].join(', ')}`;
  if (summary) return summary;
  return error?.message || fallback;
};

export const isConflict = error => error?.response?.status === 409;

export const optionalNumber = value => (value === '' || value === null || value === undefined ? null : Number(value));

export const formatNumber = value => {
  if (value === null || value === undefined || value === '') return '—';
  return new Intl.NumberFormat('mr-IN', { maximumFractionDigits: 4 }).format(Number(value));
};

export const formatCurrency = value => {
  if (value === null || value === undefined || value === '') return '—';
  return new Intl.NumberFormat('mr-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(Number(value));
};

export const fullAddress = property => [
  property?.address_line_1,
  property?.address_line_2,
  property?.locality,
  property?.ward_number ? `प्रभाग ${property.ward_number}` : null,
  property?.pincode,
].filter(Boolean).join(', ');

export const statusClass = value => String(value || '').replace(/[^a-z0-9_-]/gi, '-').toLowerCase();

export const currentInterests = interests => (interests || []).filter(item => item.status === 'active');

export const emptyProperty = {
  property_kind: 'building',
  parent_property_uid: '',
  property_name: '',
  assessment_number: '',
  property_number: '',
  survey_number: '',
  gat_number: '',
  plot_number: '',
  address_line_1: '',
  address_line_2: '',
  locality: '',
  ward_number: '',
  pincode: '',
  household_id: '',
  usage_type: 'residential',
  construction_type: '',
  property_tax_applicable: true,
  water_tax_type: 'none',
  sanitary_tax_applicable: false,
  lighting_tax_applicable: false,
  tax_applicability_reason: '',
  assessed_value: '',
  annual_rental_value: '',
  land_value: '',
  building_value: '',
  water_connection_number: '',
  water_tariff_class: '',
  water_connection_date: '',
  land_area_sqft: '',
  built_up_area_sqft: '',
  carpet_area_sqft: '',
  floor_number: '',
  total_floors: '',
  construction_year: '',
  latitude: '',
  longitude: '',
};

export const propertyPayload = form => ({
  property_kind: form.property_kind,
  parent_property_uid: form.parent_property_uid || null,
  property_name: form.property_name.trim(),
  assessment_number: form.assessment_number.trim(),
  property_number: form.property_number || null,
  survey_number: form.survey_number || null,
  gat_number: form.gat_number || null,
  plot_number: form.plot_number || null,
  address_line_1: form.address_line_1.trim(),
  address_line_2: form.address_line_2 || null,
  locality: form.locality || null,
  ward_number: form.ward_number || null,
  pincode: form.pincode || null,
  household_id: form.household_id || null,
  usage_type: form.usage_type,
  construction_type: form.construction_type || null,
  property_tax_applicable: Boolean(form.property_tax_applicable),
  water_tax_type: form.water_tax_type || 'none',
  sanitary_tax_applicable: Boolean(form.sanitary_tax_applicable),
  lighting_tax_applicable: Boolean(form.lighting_tax_applicable),
  tax_applicability_reason: form.tax_applicability_reason?.trim() || null,
  land_area_sqft: optionalNumber(form.land_area_sqft),
  built_up_area_sqft: optionalNumber(form.built_up_area_sqft),
  carpet_area_sqft: optionalNumber(form.carpet_area_sqft),
  floor_number: form.floor_number || null,
  total_floors: optionalNumber(form.total_floors),
  construction_year: optionalNumber(form.construction_year),
  latitude: optionalNumber(form.latitude),
  longitude: optionalNumber(form.longitude),
});

export const propertyValuationPayload = (form, version) => ({
  ...(version ? { version } : {}),
  valuation_date: today(),
  effective_from: today(),
  effective_to: null,
  land_value: optionalNumber(form.land_value),
  building_value: optionalNumber(form.building_value),
  assessed_value: optionalNumber(form.assessed_value),
  annual_rental_value: optionalNumber(form.annual_rental_value),
  source: 'manual',
  status: 'approved',
  notes: 'Property tax valuation approved automatically when the property form was saved.',
});
